// validators.ts
import { arrayOf, date, number, object, oneOf, optional, string } from "justus";
import { uuid } from "justus/extra/uuid";
var ratingData = {
  // "score" is always required
  score: number({ minimum: 0, maximum: 5 }),
  // "comment", "portion_size" and "order_uuid" are always optional
  comment: optional(string({ maxLength: 1024 })),
  portion_size: optional(oneOf("too_big", "just_right", "too_small"))
};
var orderData = {
  order_uuid: optional(uuid)
};
var lotData = {
  lot: optional(string({ maxLength: 32 }))
};
var createRatingValidator = object({
  ...ratingData,
  ...orderData,
  ...lotData,
  ean: optional(string({ minLength: 13, maxLength: 13 })),
  product_uuid: optional(uuid)
});
var updateRatingValidator = object({
  ...ratingData,
  score: optional(ratingData.score)
});
var ratingValidator = object({
  ...ratingData,
  ...orderData,
  ...lotData,
  // ean and product_uuid are equivalent (resolved when querying)
  ean: string({ minLength: 13, maxLength: 13 }),
  product_uuid: string(uuid),
  // basic rating entry data
  uuid,
  created: date,
  modified: date,
  // user is optional, as we allow anonymous ratings
  user_uuid: optional(uuid)
});
var averagesValidator = arrayOf(object({
  average: number,
  ean: string({ minLength: 13, maxLength: 13 }),
  product_uuid: uuid
}));
export {
  averagesValidator,
  createRatingValidator,
  ratingValidator,
  updateRatingValidator
};
//# sourceMappingURL=validators.mjs.map
